<template>
  <div class="d-flex flex-column-reverse">
    <div
      class="position-absolute top-0 w-100 d-flex justify-content-center pt-3"
    >
      <div class="w-75">
        <b-form @submit.prevent="searchSubmit">
          <b-input-group class="mb-2">
            <b-input-group-prepend class="bg-skyler" :class="icon">
              <i-search width="1em" height="1em"></i-search>
            </b-input-group-prepend>

            <b-input
              v-model="query"
              class="rounded-pill shadow-none"
              :class="search"
              :disabled="disabled"
              :placeholder="t('Enter keyword to search')"
              size="sm"
            />
          </b-input-group>
        </b-form>

        <div class="d-flex justify-content-between mb-2">
          <b-button
            :class="{ 'bg-white': type !== 1 }"
            :variant="type !== 1 ? 'outline-primary' : 'primary'"
            @click="type = 1"
            class="rounded-pill flex-1"
            :disabled="disabled"
            size="sm"
          >
            {{ t("Doctors") }}
          </b-button>

          <b-button
            :class="{ 'bg-white': type !== 2 }"
            @click="type = 2"
            :variant="type !== 2 ? 'outline-primary' : 'primary'"
            class="rounded-pill flex-1 mx-2"
            :disabled="disabled"
            size="sm"
          >
            {{ t("Labs") }}
          </b-button>

          <b-button
            :class="{
              'bg-white': type != null,
              magenta: type != null,
              'bg-magenta': type === null,
            }"
            @click="type = null"
            class="rounded-pill flex-1 border-magenta"
            :disabled="disabled"
            size="sm"
          >
            {{ t("All") }}
          </b-button>
        </div>

        <b-form-select
          size="sm"
          v-if="type === 1"
          class="rounded-pill"
          v-model="specialization"
          :options="specializations"
          value-field="id"
          :text-field="nameKey"
        ></b-form-select>
      </div>
    </div>

    <div
      class="position-absolute w-100 border-top-radius elevation-1 bg-white py-3"
    >
      <div class="mx-3 overflow-auto d-flex">
        <template
          v-for="(
            { addresses, personal_image, first_name, last_name }, index
          ) in practitioners"
        >
          <template>
            <div
              class="bg-grad-2 rounded position-relative"
              :class="margin"
              :key="index"
            >
              <img
                class="rounded cover-img"
                width="100rem"
                height="100rem"
                :src="
                  personal_image
                    ? personal_image.full_url
                    : require('../assets/img/placeholders/practitioner.png')
                "
              />

              <small
                class="fixed-bottom position-absolute px-1 d-flex font-weight-bolder"
                style="font-size: 15px"
                >{{ first_name + " " + last_name }}</small
              >
            </div>
          </template>
        </template>
      </div>
    </div>

    <b-modal
      id="details"
      scrollable
      centered
      hide-footer
      header-class="pl-4 bg-light-skyler align-items-center"
      content-class="border-radius-1"
    >
      <template slot="modal-header" v-if="practitioners[index]">
        <div>
          <b-avatar
            size="120"
            :src="
              practitioners[index].personal_image
                ? practitioners[index].personal_image.full_url
                : require('../assets/img/placeholders/practitioner.png')
            "
          ></b-avatar>
        </div>
        <div class="px-1 mx-2 modal-title">
          <h5>
            {{ practitioners[index].first_name }}
            {{ practitioners[index].last_name }}
          </h5>
          <h6 v-if="practitioners[index].specialization_id">
            {{
              specializations.find(
                (specialization) =>
                  specialization.id === practitioners[index].specialization_id
              )[nameKey]
            }}
          </h6>
        </div>
        <button
          type="button"
          aria-label="Close"
          @click="$bvModal.hide('details')"
          class="close align-self-start"
        >
          ×
        </button>
      </template>

      <template v-if="practitioners[index]">
        <b-overlay :show="show" :rounded="true">
          <div>
            <small class="d-block font-weight-bolder">{{
              t("More information")
            }}</small>
            <small
              class="d-block"
              v-html="practitioners[index].description"
            ></small>
          </div>
        </b-overlay>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ISearch from "../components/Icons/ISearch";
import IGps from "../components/Icons/IGps";
import ILabPin from "../components/Icons/ILabPin";
import IPractitionerPin from "../components/Icons/IPractitionerPin";

export default {
  name: "Home",
  components: {
    ISearch,
    IGps,
    ILabPin,
    IPractitionerPin,
  },
  inject: ["dataRepo", "localStorageRepo"],
  data: () => ({
    center: [0, 0],
    practitioners: [],
    zoom: 1,
    type: null,
    disabled: false,
    query: null,
    specialization: null,
    specializations: [],
    index: null,
    geoJsonLayer: {
      id: "route",
      type: "line",
      source: "geoJsonSource",
      layout: {
        "line-join": "round",
        "line-cap": "round",
      },
      paint: {
        "line-color": "#8cabff",
        "line-width": 8,
      },
    },
    geoJsonSource: {
      type: "geojson",
      data: {
        type: "Feature",
        properties: {},
        geometry: {
          type: "LineString",
          coordinates: [],
        },
      },
    },
    currentLocation: null,
    accessToken:
      "pk.eyJ1IjoieWFoeWEtaGlyby1oZWFsdGgiLCJhIjoiY2ttc3h5Ym5sMG1pcDJybzVhM2RyMHkyMCJ9.nsI8mBKIGJEY6tByuYGtZw",
    style: "mapbox://styles/mapbox/streets-v11?optimize=true",
    show: true,
    interval: null,
  }),
  computed: {
    search() {
      return this.$translate.lang === "en" ? "search" : "search-rtl";
    },

    icon() {
      return this.$translate.lang === "en" ? "icon" : "icon-rtl";
    },

    margin() {
      return this.$translate.lang === "en" ? "mr-3" : "ml-3";
    },

    nameKey() {
      return `name_${this.$translate.lang}`;
    },
  },
  watch: {
    type() {
      this.getPractitioners();
    },

    specialization() {
      this.getPractitioners();
    },
  },
  methods: {
    searchSubmit() {
      this.getPractitioners();
    },

    centerUpdated(center) {
      this.zoom = 15;
      this.center = center;
    },

    loaded(evt) {
      this.actions = evt.component.actions;

      window.setCenter = this.locationHandler;
      window.trackHandler = this.trackHandler;

      this.getPractitioners();
    },

    setCenter() {
      if (window.webkit && "callbackHandler" in window.webkit.messageHandlers) {
        window.webkit.messageHandlers.callbackHandler.postMessage(1);
      } else {
        navigator.geolocation.getCurrentPosition(this.locationHandler);
      }
    },

    startTracking() {
      this.interval = setInterval(() => {
        if (
          window.webkit &&
          "callbackHandler" in window.webkit.messageHandlers
        ) {
          window.webkit.messageHandlers.callbackHandler.postMessage(2);
        } else {
          navigator.geolocation.getCurrentPosition(this.trackHandler);
        }
      }, 10000);
    },

    locationHandler({ coords: { latitude: lat, longitude: lng } }) {
      this.updateCurrentLocation(lng, lat);
      this.centerUpdated([lng, lat]);
    },

    updateCurrentLocation(lng, lat) {
      this.currentLocation = [lng, lat];
      this.localStorageRepo.setLocation([lng, lat]);
      this.dataRepo.storePatientLocationLog({ lat, lon: lng });
    },

    trackHandler({ coords: { latitude: lat, longitude: lng } }) {
      this.updateCurrentLocation(lng, lat);
    },

    getRoute() {
      const { addresses: pracitioner_addresses } =
        this.practitioners[this.index];

      this.dataRepo
        .getRoute(
          this.currentLocation[1],
          this.currentLocation[0],
          pracitioner_addresses[0].lat,
          pracitioner_addresses[0].long
        )
        .then(({ data }) => {
          const coords = data.routes[0].geometry.coordinates;
          this.geoJsonSource.data.geometry.coordinates =
            data.routes[0].geometry.coordinates;
          this.actions.fitBounds([coords[0], coords[coords.length - 1]], {
            padding: {
              top: 130,
              bottom: 180,
              left: 50,
              right: 50,
            },
          });
        });
    },

    setCenterFromPractitioners() {
      this.practitioners.forEach(({ addresses: practitioner_addresses }) => {
        practitioner_addresses.forEach(({ lat, long: lng }) => {
          lat &&
            lng &&
            !this.center[0] &&
            !this.center[1] &&
            this.centerUpdated([lng, lat]);
        });
      });
    },

    getPractitioners() {
      this.practitioners = [];
      this.disabled = true;

      this.dataRepo
        .practitioners(this.type, this.query, this.specialization)
        .then(({ data: practitioners }) => {
          if (practitioners) {
            this.practitioners = practitioners;

            if (!this.center[0] && !this.center[1]) {
              this.setCenterFromPractitioners();
            }
          }
        })
        .catch((err) => this.$handleError(err))
        .finally(() => {
          this.disabled = false;
        });
    },

    open(index, updateCenter = false) {
      this.index = index;

      if (this.currentLocation) {
        this.getRoute();
      }

      this.$refs["popup"].forEach((popUp) => (popUp.open = false));
      this.$refs["popup"][index].open = true;

      if (updateCenter) {
        const { addresses: pracitioner_addresses } = this.practitioners[index];
        this.centerUpdated([
          pracitioner_addresses[0].long,
          pracitioner_addresses[0].lat,
        ]);
      } else {
        if (this.practitioners[index].loadedDescription) {
          this.show = false;
        } else {
          this.show = true;

          this.dataRepo
            .practitionerDescription(this.practitioners[index].id)
            .then(({ data }) => {
              this.practitioners[index].description = data;
              this.practitioners[index].loadedDescription = true;
            })
            .finally(() => (this.show = false));
        }

        this.$bvModal.show("details");
      }
    },
  },
  beforeMount() {
    this.localStorageRepo.getLocation().then((latLonObj) => {
      latLonObj && this.centerUpdated(latLonObj);
      this.setCenter();
      this.startTracking();
    });
  },
  mounted() {
    this.dataRepo
      .specializations()
      .then(({ data: specializations }) => {
        this.specializations = specializations;

        this.specializations.unshift({
          id: null,
          [this.nameKey]: this.t("Select a specialization"),
        });
      })
      .catch((err) => this.$handleError(err));
    this.getPractitioners();
  },
  beforeDestroy() {
    delete window.setCenter;
    delete window.trackHandler;
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.top-0 {
  top: 0;
}

.cover-img {
  opacity: 0.3;
}

.bottom-0 {
  bottom: 0;
}

.fab {
  bottom: 8.5rem;
  right: 0;
}

.circle {
  height: 18px;
  width: 18px;
  border-radius: 50%;
}

.current {
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.modal-title {
  border-left: white solid 2px;
}

.pop-up {
  text-decoration: underline;
  color: #3266f5;
}

.red {
  background-color: #e21851;
}

.blue {
  background-color: #3266f5;
}

.search {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.icon {
  border-top-left-radius: 50rem !important;
  border-bottom-left-radius: 50rem !important;
  padding: 0.4rem !important;
}

.search-rtl {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.icon-rtl {
  border-top-right-radius: 50rem !important;
  border-bottom-right-radius: 50rem !important;
  padding: 0.4rem !important;
}
</style>
